import { buildSaleReceipt, type SaleReceiptPayload } from '@vuelto/print';
import type { PrintJobResult } from '../domain/printConfig';
import { printThermalDocumentJob } from './printThermalDocument';
import { getBranchReceiptPrintConfig } from '../infra/printConfigRepo';

export async function printSaleReceiptJob(
  branchId: string,
  payload: SaleReceiptPayload
): Promise<PrintJobResult> {
  const config = await getBranchReceiptPrintConfig(branchId);
  const document = buildSaleReceipt({ ...payload, widthMm: config.widthMm });
  return printThermalDocumentJob(branchId, document, { blockWhenModeOff: true });
}

export async function shouldAutoPrintSaleReceipt(branchId: string): Promise<boolean> {
  const config = await getBranchReceiptPrintConfig(branchId);
  return config.mode !== 'off' && config.autoPrint;
}

export async function shouldAutoPrintKitchenComanda(branchId: string): Promise<boolean> {
  const config = await getBranchReceiptPrintConfig(branchId);
  return config.autoPrintComanda;
}
